import React from 'react';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { Button } from 'antd';
import { useStateValue } from '../../providers/StateProvider';

const ChangeTheme = () => {
    const [{ theme }, dispatch] = useStateValue();

    const handleChangeTheme = () => {
        dispatch({
            type: 'CHANGE_THEME',
            item: { theme: theme === 'dark' ? 'light' : 'dark' },
        });
    };

    return (
        <div className="d-flex flex-row">
            {theme === 'dark'
                ? <BulbOutlined className="mr-3 align-self-center" />
                : <BulbFilled className="mr-3 align-self-center" />}

            <Button type="link" className="mt-3" onClick={handleChangeTheme}>
                Cambiar a tema
                {' '}
                {theme === 'light' ? 'oscuro' : 'claro'}
            </Button>

        </div>
    );
};
export default ChangeTheme;
